import CityPageTemplate from "../city-template/CityPageTemplate";
import { tacomaConfig } from "./data";

export default function TacomaPage() {
  return <CityPageTemplate config={tacomaConfig} />;
}